// extracted by mini-css-extract-plugin
export default {"m":"TradeType_m__eyWXA","m_box":"TradeType_m_box__-SenP","mBox":"TradeType_m_box__-SenP"};